document.addEventListener("DOMContentLoaded", function () {
    managingJobsDesctiptionATags()
});

function managingJobsDesctiptionATags() {
    let descriptionTags = document.querySelectorAll(".single-jobs .job_detail_description");
  
    if (descriptionTags.length > 0) {
      descriptionTags.forEach(selectedTag => {
        const pTags = selectedTag.querySelectorAll("p");
        pTags.forEach(p => {
          const onlyHasATags = Array.from(p.childNodes).every(node => {
            return (
              (node.nodeType === 1 && node.tagName.toLowerCase() === 'a') || 
              (node.nodeType === 3 && node.textContent.trim() === "")
            );
          });
  
          if (onlyHasATags) {
            const links = p.querySelectorAll("a");
            links.forEach(link => link.classList.add("jobs_desc_button"));
          }
        });
      });
    }
  }
  